import * as Styled from './Toggle.styles'

import React from 'react'
import { ToggleProps } from './Toggle.types'

const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
	({ checked, className, id, label, name, onChange, ...props }, ref) => {
		return (
			<Styled.Toggle className={className}>
				<Styled.ToggleCheckbox
					checked={checked}
					id={id}
					name={name ?? id}
					onChange={onChange}
					{...props}
					ref={ref}
				/>
				<Styled.ToggleButton />
				{label}
			</Styled.Toggle>
		)
	}
)

Toggle.displayName = 'Toggle'

export default Toggle
